<template>
  <div :class="$style.footer">
    <div :class="$style.typeList">
      <div
        :class="[$style.subType, !item.selected ? $style.disabled : '']"
        v-for="item in typeList"
        :key="item.name"
        @click="handleSelectType(item)"
      >
        <div
          :class="[$style.typeBg, !item.selected ? $style.disabled : '']"
          :style="{
            background: `radial-gradient(circle,${item.color},rgba(218, 32, 49, 0))`,
          }"
        ></div>
        <a-icon
          :class="$style.icon"
          :type="item.icon"
          theme="filled"
          v-if="item.type !== 'ONLINE'"
        />
        <i v-html="item.icon" style="width: 0.24rem;" v-else></i>
        <span>{{ item.name }}</span>
        <span :class="$style.count">{{ item.number }}</span>
        <span :class="$style.font">{{ $t('hat.screen.devices') }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator';
import { getTypeStatic } from '@/services/smart-hat/screen';
import { checkHasShare } from '@/views/hat/screen/utils';
import { getTypeStatic as shareData } from '@/services/smart-hat/screen-share';
import { Emitter } from '@/utils';
import { DEVICE_TYPE } from './map/index.vue';
import OnlineIcon from '!!svg-inline-loader!@/assets/images/smart-hat/screen/online.svg';

@Component()
export default class HatScreenFooter extends Vue {
  typeList = [];
  async getTypeStatic(params) {
    const param = {
      groupIdList: params.groupIdList.toString(),
      projectIds: params.projectIds.toString(),
      searchDayEnum: params.searchDayEnum,
    };
    const data = !checkHasShare(this.$route)
      ? await getTypeStatic(param)
      : await shareData(param, {
          shareId: this.$route.params.id,
          password: this.$route.params.password,
        });
    if (this.typeList.length > 0) {
      this.typeList[0].number = data.alarm;
      this.typeList[1].number = data.remind;
      this.typeList[2].number = data.notice;
      this.typeList[3].number = data.normal;
      if (params.reset) {
        this.typeList[0].selected = true;
        this.typeList[1].selected = true;
        this.typeList[2].selected = true;
        this.typeList[3].selected = true;
      }
    } else {
      this.typeList = [
        {
          name: this.$t('hat.managementModal.personInfo.online'),
          number: data.onLine,
          color: 'rgba(9, 255, 0, 1)',
          icon: OnlineIcon,
          selected: false,
          type: 'ONLINE',
        },
        {
          name: this.$t('hat.screen.alarm'),
          number: data.alarm,
          icon: 'warning',
          color: 'rgba(218, 32, 49, 1)',
          selected: true,
          type: DEVICE_TYPE.ALARM,
        },
        {
          name: this.$t('hat.screen.remind'),
          number: data.remind,
          icon: 'bell',
          color: 'rgba(255, 221, 0, 1)',
          selected: true,
          type: DEVICE_TYPE.REMIND,
        },
        {
          name: this.$t('hat.screen.notice'),
          number: data.notice,
          icon: 'sound',
          color: 'rgba(0, 111, 185, 1)',
          selected: true,
          type: DEVICE_TYPE.NOTICE,
        },
        {
          name: this.$t('hat.screen.normal'),
          number: data.normal,
          icon: 'check-circle',
          color: 'rgba(0, 137, 82, 1)',
          selected: true,
          type: DEVICE_TYPE.NORMAL,
        },
      ];
    }
  }
  handleSelectType(item) {
    item.selected = !item.selected;
    Emitter.$emit('device-type', item);
  }
}
</script>
<style lang="less" module>
.footer {
  height: 0.69rem;
  width: auto;
  position: absolute;
  z-index: 100;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  .typeList {
    height: 100%;
    width: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .subType {
      width: 1.73rem;
      height: 0.4rem;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      font-size: 0.16rem;
      position: relative;
      &.disabled {
        color: #cccccc;
      }
      .font {
        font-size: 0.16rem;
      }
      .typeBg {
        width: 1.73rem;
        height: 0.35rem;
        border-radius: 50%;
        filter: blur(0.08rem);
        opacity: 0.4;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        &.disabled {
          background: none !important;
        }
      }
      .icon {
        font-size: 0.24rem;
      }
      & > span:first-of-type {
        margin: 0 0.12rem;
      }
      & .count {
        font-size: 0.22rem;
      }
    }
  }
}
</style>
